module.exports = __webpack_public_path__ + "9912c13c8f68e90de01bfce1dd898ee4.svg";